import { createFileRoute } from '@tanstack/react-router';

import { CoursesExplorerRoot } from '@/features/courses-explorer/components/CoursesExplorerRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/_app/app/courses')({
  component: CoursesRoute,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
});

function CoursesRoute() {
  return (
    <AppPageContent>
      <AppPageHeader
        breadcrumbItems={[
          {
            label: 'Home',
            link: { to: '/app' },
          },
          {
            label: 'Administration',
            link: { to: '/app' },
          },
          {
            label: 'Courses',
            link: { to: '/app/courses' },
          },
        ]}
      />
      <CoursesExplorerRoot />
    </AppPageContent>
  );
}
